export default "__VITE_ASSET__Dra3D$mS__"